import { locales } from 'utils/locales';
import { setupI18n } from 'utils/i18/i18n';
import activeLocale from 'stores/activeLocale';

/** @type {import('./$types').PageLoad} */
export async function load({ params, data }) {
	const lang = locales.includes(params.lang) ? params.lang : 'en';

	activeLocale.set({
		locale: lang,
	});

	await setupI18n(lang);

	return {
		lang,
		device: {
			isMobile: data.isMobile,
		},
	};
}
